module.exports = __webpack_public_path__ + "media/images/flf-anilina_pigmented-f5193e50883138b21388adcef30a90b8.jpg";